import { render, staticRenderFns } from "./setAssignLead.vue?vue&type=template&id=07d9db3e"
import script from "./setAssignLead.vue?vue&type=script&lang=js"
export * from "./setAssignLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports